<ng-container *ngIf="standingAuthSelection === 'bundled-yes'">
	<mm-standing-authorization-card-container
		*ngIf="enableUseSloaContainer; else legacyBundledStandingAuthControl"
		[label]="'Select standing authorization'"
		[authorizationCount]="bundledStandingAuthCards.length"
		[cards]="bundledStandingAuthCards"
		(cardSelected)="onStandingAuthCardSelected($event)">
	</mm-standing-authorization-card-container>
	<ng-template #legacyBundledStandingAuthControl>
		<mm-card-component [parentForm]="parentForm" [cardModel]="bundledCardModel"></mm-card-component>
	</ng-template>
</ng-container>
<ng-container *ngIf="standingAuthSelection === 'yes'">
	<mm-standing-authorization-card-container
		*ngIf="enableUseSloaContainer; else legacyStandingAuthControl"
		[label]="'Select standing authorization'"
		[authorizationCount]="standingAuthCards.length"
		[cards]="standingAuthCards"
		(cardSelected)="onStandingAuthCardSelected($event)">
	</mm-standing-authorization-card-container>
	<ng-template #legacyStandingAuthControl>
		<mm-card-component [parentForm]="parentForm" [cardModel]="standingAuthCardModel"></mm-card-component>
	</ng-template>
</ng-container>
<mm-banners *ngIf="showStandingAuthWarning"
[bannerText]="['There are no standing authorizations on this account.']" [type]="'error'" class="big-bottom-spacer">
</mm-banners>